import dayjs from 'dayjs';

export const TODAY = dayjs();
